import React from 'react';

interface PreviewProps {
    onStart: () => void;
}

const Preview: React.FC<PreviewProps> = ({ onStart }) => {
    return (
        <div className="preview-container">
            <div className="preview-card">
                {/* Üst başlık ve ikonlar */}
                <div className="preview-header">
                    <span className="preview-title">HappAI</span>
                    <span className="preview-close">&#10006;</span>
                </div>
                {/* Robot görseli */}
                <img src="/images/robot.svg" alt="robot" className="preview-robot" />
                {/* Hoşgeldin başlığı */}
                <h1 className="preview-welcome">Hoşgeldin!</h1>
                {/* Emoji */}
                <div className="preview-emoji">👋</div>
                {/* Açıklama metinleri */}
                <div className="preview-text-primary">
                    HappAI ile şimdi konuş.
                </div>
                <div className="preview-text-secondary">
                    Bana her konuda soru sorabilirsin.
                </div>
                {/* Buton */}
                <button className="preview-button" onClick={onStart}>
                    Konuşmaya Başla
                </button>
            </div>
        </div>
    );
};

export default Preview; 